import styled from 'styled-components';
import {
  SYS_PAGE_MARGIN_XS,
  SYS_PAGE_MARGIN_SM,
  SYS_PAGE_MARGIN_MD,
  SYS_PAGE_MARGIN_LG,
  SYS_PAGE_MARGIN_XL,
  SYS_SPACE_FIXED_350,
  SYS_SPACE_FIXED_500,
  SYS_SPACE_FIXED_2000,
  SYS_BREAKPOINT_SM,
  SYS_BREAKPOINT_MD,
  SYS_BREAKPOINT_LG,
  SYS_BREAKPOINT_XL,
} from '@oneaudi/unified-web-common';

export const PageMargin = styled.div`
  margin: 0 ${SYS_PAGE_MARGIN_XS};
  padding-top: ${SYS_PAGE_MARGIN_XL};
  padding-bottom: ${SYS_PAGE_MARGIN_MD};
  display: grid;
  grid-template-columns: 1fr;

  @media (min-width: ${SYS_BREAKPOINT_SM}) {
    margin: 0 ${SYS_PAGE_MARGIN_SM};
  }

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    margin: 0 ${SYS_PAGE_MARGIN_MD};
    padding-top: ${SYS_PAGE_MARGIN_XL};
    padding-bottom: ${SYS_PAGE_MARGIN_MD};
    grid-template-columns: repeat(12, 1fr);
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    margin: 0 ${SYS_PAGE_MARGIN_LG};
    padding-top: ${SYS_SPACE_FIXED_2000};
    padding-bottom: ${SYS_PAGE_MARGIN_XL};
  }

  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    margin: 0 ${SYS_PAGE_MARGIN_XL};
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  white-space: nowrap;
`;

export const TextContainer = styled.div`
  margin-top: ${SYS_SPACE_FIXED_350};
  margin-bottom: ${SYS_SPACE_FIXED_500};
`;

export const Container = styled.section`
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    grid-column: 3 / span 8;
  }
  text-align: center;
`;
